<template>
  <div>
    <Modal v-model="modal" :title="!storageGatewayWarningForm.id ? this.$t('alarms.storagegateway.addStorageGatewayAlarm'):this.$t('alarms.storagegateway.editStorageGatewayAlarm')" @on-cancel="cancel" @on-ok="ok" :loading="loading" :mask-closable="false" :styles="{top:'65px'}" width="800px" :footer-hide="true" :closable="false">
      <Form ref="storageGatewayWarningForm" :model="storageGatewayWarningForm" :label-width="110" :rules="ruleValidate">
        <!-- 下一步 -->
        <div v-show="isNext">
          <!-- 微信警告 -->
          <wechat-warning v-if="wechatWarningVisible" ref="wechatWarning"></wechat-warning>
          <!-- 规则名称 -->
          <FormItem :label="$t('alarms.common.ruleName')" prop="ruleName" v-if="isEditRuleName">
            <Row>
              <Col span="11">
                <Input type="text" v-model="storageGatewayWarningForm.ruleName" placeholder="Enter something..."
                       style="width:300px;" :disabled="isEdit"></Input>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则名称 -->
          <FormItem :label="$t('alarms.common.ruleName')" v-if="showRuleName">
            <Row>
              <Col span="24">
                <div>{{this.storageGatewayWarningForm.ruleName}}</div>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则描述 -->
          <FormItem :label="$t('alarms.common.ruleDescription')">
            <Row :gutter="4">
              <!-- 监控指标 -->
              <Col span="4">
                <FormItem prop="monitorIndex">
                  <Select v-model="storageGatewayWarningForm.monitorIndex"
                          @on-change="changeMonitorIndex(storageGatewayWarningForm.monitorIndex)" :placeholder="$t('alarms.common.pleaseSelect')">
                    <Option :value="item.id" v-for="item in monitorIndexList" :key="item.id">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 周期 -->
              <Col span="3">
                <FormItem prop="cycle">
                  <Select v-model="storageGatewayWarningForm.cycle" :placeholder="$t('alarms.common.cycle')" @on-change="changeCycle(storageGatewayWarningForm.cycle)">
                    <Option :value="item.id" v-for="(item,index) in cycleList" v-bind:key="index">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 连续周期 -->
              <Col span="4">
                <FormItem prop="continousCycle">
                  <Select v-model="storageGatewayWarningForm.continousCycle" :placeholder="$t('alarms.common.continuousCycle')"
                          @on-change="changeContinousCycle(storageGatewayWarningForm.continousCycle)">
                    <Option :value="item.id" v-for="(item,index) in continousCycleList" v-bind:key="index">
                      {{item.name}}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 统计数值 -->
              <Col span="4">
                <FormItem prop="statisticsValue">
                  <Select v-model="storageGatewayWarningForm.statisticsValue" :placeholder="$t('alarms.common.statisticsValue')"
                          @on-change="changeStatisticsValue(storageGatewayWarningForm.statisticsValue)">
                    <Option :value="item.id" v-for="(item,index) in statisticsValueList" v-bind:key="index">
                      {{item.name}}
                    </Option>
                  </Select>
                </FormItem>
              </Col>


              <!-- 如果监控指标为集群状态（黄色）、集群状态（红色）、主节点时 不显示符号、阈值和单位 -->
              <div v-if="this.isShowField!=1">
                <!-- 关系符号 -->
                <Col span="3">
                  <FormItem prop="relationshipSign">
                    <Select v-model="storageGatewayWarningForm.relationshipSign"
                            @on-change="changeRelationshipSign(storageGatewayWarningForm.relationshipSign)"
                            :placeholder="$t('alarms.common.symbol')">
                      <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index">
                        {{item.name}}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
                <!-- 阈值 -->
                <Col span="3">
                  <FormItem prop="thresholdValue">
                    <Input v-model="storageGatewayWarningForm.thresholdValue" :placeholder="$t('alarms.common.threshold')"
                           type="number" disabled></Input>
                  </FormItem>
                </Col>
              </div>
              <div v-else-if="this.isShowField==2">
                <!-- 关系符号 -->
                <Col span="3">
                  <FormItem prop="relationshipSign">
                    <Select v-model="storageGatewayWarningForm.relationshipSign"
                            @on-change="changeRelationshipSign(storageGatewayWarningForm.relationshipSign)"
                            :placeholder="$t('alarms.common.symbol')">
                      <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index">
                        {{item.name}}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
                <!-- 阈值 -->
                <Col span="3">
                  <FormItem prop="thresholdValue">
                    <Input v-model="storageGatewayWarningForm.thresholdValue" :placeholder="$t('alarms.common.threshold')"
                           type="number"></Input>
                  </FormItem>
                </Col>
                <!-- 单位 -->
                <Col span="2">
                  <FormItem prop="unit">
                    <Input v-model="storageGatewayWarningForm.unit" disabled :placeholder="$t('alarms.common.unit')"></Input>
                  </FormItem>
                </Col>
              </div>
            </Row>
          </FormItem>

          <!-- 联系方式 -->
          <FormItem :label="$t('alarms.common.contactType')" prop="contactType">
              <RadioGroup v-model="storageGatewayWarningForm.contactType" @on-change="changeContactType(storageGatewayWarningForm.contactType)">
                  <Radio v-for="item in contactTypeList" :label="item.type" :key="item.value">{{item.label}}</Radio>
              </RadioGroup>
          </FormItem>

          <!-- 通知对象 -->
          <FormItem :label="$t('alarms.common.notificationObject')" prop="notificationObject" v-if="storageGatewayWarningForm.contactType==0">
            <Select v-model="storageGatewayWarningForm.notificationObject" multiple style="width:300px;" @on-change="changeNotificationObject" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in notificationObjectList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 联系人组 -->
          <FormItem :label="$t('alarms.common.contactGroup')" prop="contactGroupIds" v-if="storageGatewayWarningForm.contactType==1">
            <Select v-model="storageGatewayWarningForm.contactGroupIds" multiple style="width:300px;" @on-change="changeContactGroupId(storageGatewayWarningForm.contactGroupIds)" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in contactGroupIdList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 报警方式 -->
          <FormItem :label="$t('alarms.common.noticeType')" prop="noticeType">
            <Select v-model="storageGatewayWarningForm.noticeType" multiple style="width:300px;" @on-change="selectnoticeType(storageGatewayWarningForm.noticeType)" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in alarmWayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 企业微信机器人URL -->
          <FormItem :label="$t('alarms.common.enterpriseWeChatRobotURL')" prop="enterpriseWechatRobotIds" v-if="storageGatewayWarningForm.noticeType.filter(function (e) { return e == 3; }).length != 0">
            <Select v-model="storageGatewayWarningForm.enterpriseWechatRobotIds" multiple style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in enterpriseWechatRobotIdsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 延迟告警 -->
          <FormItem :label="$t('alarms.common.alarmDelay')" prop="alarmDelay">
            <Select v-model="storageGatewayWarningForm.alarmDelay" style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in alarmDelayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 监控时段 -->
          <FormItem :label="$t('alarms.common.monitorPeriod')" prop="monitorPeriod">
            <Select v-model="storageGatewayWarningForm.monitorPeriod" style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in monitorPeriodList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 邮箱模板 -->
          <div v-show="isShowEmail">
            <FormItem :label="$t('alarms.common.emailModal')" prop="emailModal">
              <Input v-model="storageGatewayWarningForm.emailModal" type="textarea"
                     :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
            </FormItem>
          </div>

          <!-- 企业微信模板 -->
          <div v-show="isShowWeChat">
            <FormItem :label="$t('alarms.common.wechatModal')" prop="wechatModal">
              <Input v-model="storageGatewayWarningForm.wechatModal" type="textarea"
                     :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
            </FormItem>
          </div>
          <div style="height: 42px;">
            <Button type="primary" size="large" style="float: right;" @click="ok('storageGatewayWarningForm')" :loading="addloading" :disabled="isAddOrEdit">
              {{!storageGatewayWarningForm.id ? this.$t('common.addAlarm'):this.$t('common.editAlarm')}}
            </Button>
            <Button size="large" style="float: right;margin-right: 10px;"
                    @click="cancel('storageGatewayWarningForm')">{{ $t('alarms.common.cancel') }}
            </Button>
            <Button size="large" @click="previousPage" style="float: right;margin-right: 10px;">{{ $t('alarms.common.lastStep') }}</Button>
          </div>
        </div>

        <!-- 上一步 -->
        <div v-show="isPrevious">
          <div>
            <Row :gutter="16">
              <Col span="8">
                <!-- 账户 -->
                <FormItem :label="$t('alarms.common.account')" prop="account" :label-width="50">
                  <Select v-model="storageGatewayWarningForm.account" @on-change="changeAccount(storageGatewayWarningForm.account)" :transfer="true" :placeholder="$t('alarms.common.pleaseSelect')">
                    <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="10" style="z-index: 200">
                <!-- 存储区域 -->
                <FormItem :label="$t('alarms.common.region')" prop="backupRegion">
                  <Select @on-change="changebackupRegion(storageGatewayWarningForm.backupRegion)"
                          v-model="storageGatewayWarningForm.backupRegion" multiple :max-tag-count="1"
                          :transfer="true"
                          :placeholder="$t('alarms.common.pleaseSelect')">
                    <Checkbox v-model="singleBackupRegion" @on-change="selectBackupRegionAll" style="display: block;text-align:right;">
                      {{ $t('alarms.common.allSelected') }}
                    </Checkbox>
                    <Option :value="item.name" v-for="item in backupRegionList" :key="item.id">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Button type="primary" style="float:right;" v-show="isShowSearch" @click="searchStorageGatewayDate">{{ $t('alarms.common.search') }}</Button>
            </Row>
          </div>

          <v-table :height="459" column-width-drag is-horizontal-resize
                   style="width:100%;height:459px;margin-bottom: 15px;" :columns="column" :table-data="tableStorageGatewayDate"
                   row-hover-color="#edf7ff" :is-loading="modal_loadings" title-bg-color="#f8f8f9"
                   :select-group-change="selectChange" :select-all="selectAll"></v-table>
          <div style="height: 42px;">
            <Button type="primary" size="large" @click="nextPage" style="float: right;" :disabled="isNextClick">{{ $t('alarms.common.nextStep') }}
            </Button>
            <Button size="large" style="margin-right: 10px;float: right;"
                    @click="cancel('storageGatewayWarningForm')">{{ $t('alarms.common.cancel') }}
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
    import WechatWarning from '../common/WechatWarning.vue'
    import {setCookie, getCookie} from '../../../utils/cookieUtil.js'
    import TableStorageGateway from '../storage_gateway/TableStorageGateway.vue'

    const tableStorageGateway = TableStorageGateway;
    let tableStorageGatewayWarningVue = {};
    export default {
        inject: ['reload'],
        components: {
            WechatWarning
        },
        data() {
            // 名字是否重复
          const validNameRepeatedCheck = (rule, value, callback) => {
            const self = this;
            self.$api.alertRule.nameRepeatedCheck({
              "alertRuleName": this.storageGatewayWarningForm.ruleName,
              "monitorModule": this.monitorModule
            })
              .then(res => {
                if (res.status == 200) {
                  callback();
                }
              })
              .catch(err => {
                if (err.status == 400) {
                  callback(new Error('规则名称不能重复!'));
                }
              })
          };
          return {
                monitorModule:35,
                isAddOrEdit:true,
                wechatWarningVisible: false,
                contactTypeList: [{
                    label: this.$t('alarms.common.contactPerson'),
                    value: 'contact',
                    type: 0
                },
                    {
                        label: this.$t('alarms.common.contactGroup'),
                        value: 'contactGroup',
                        type: 1
                    }],
                isShowField: '', //是否显示符号、阈值和单位
                addloading:false,
                singleBackupRegion:false,
                alarmDelayList:[],
                monitorPeriodList:[],
                isEdit: false,
                isShowSearch: false,
                isEditRuleName: false,
                showRuleName: false,
                modal_loadings: false,
                isShowEmail: false,
                isShowWeChat: false,
                isNext: false,
                isPrevious: true,
                selection: [],
                accountList: [],
                notificationObjectList: [],
                alarmWayList: [],
                backupRegionList: [],
                loading: true,
                modal: false,
                modal_loading: false,
                exportDataList: '',
                noticeType: [],
                units: '',
                isNextClick: true, //禁止点击下一步
                unit: '',
                storageGatewayWarningForm: {
                    account: '',
                    ruleName: '',
                    notificationObject: [],
                    noticeType: [],
                    emailModal: '',
                    wechatModal: '',
                    thresholdValue: '',
                    monitorIndex: '',
                    cycle: '',
                    continousCycle: '',
                    statisticsValue: '',
                    relationshipSign: '',
                    unit: '',
                    backupRegion: [],
                    alarmDelay:'',
                    monitorPeriod:'',
                    contactType:0,
                    contactGroupIds:[],
                    userIdList:[],
                    enterpriseWechatRobotIds:[]
                },
                enterpriseWechatRobotIdsList:[],
                // 联系人组
                contactGroupIdList:[],
                // 监控指标
                monitorIndexList: [],
                // 周期
                cycleList: [],
                // 连续周期
                continousCycleList: [],
                // 统计数值
                statisticsValueList: [],
                // 关系符号
                relationshipSignList: [],
                ruleValidate: {
                    account: [
                        {required: true, message: '请选择账户名称', trigger: 'change', type: 'number'}
                    ],
                    alarmDelay: [
                        {required: true, message: '请选择延迟告警', trigger: 'change', type: 'number'}
                    ],
                  monitorPeriod: [
                    {required: true, message: '请选择监控时段', trigger: 'change', type: 'number'}
                  ],
                    backupRegion: [
                        {required: true, type: 'array', message: '请选择存储区域', trigger: 'change'}
                    ],
                    ruleName: [
                        {required: true, message: '规则名称不能为空', trigger: 'blur'},
                        {type: 'string', message: '规则名称为2-20个字符首尾中间不能有空格', pattern: '^[^ ]{2,20}$', trigger: 'blur'},
                        {validator: validNameRepeatedCheck, trigger: 'blur'}
                    ],
                    notificationObject: [
                        {required: true, type: 'array', message: '请选择通知对象', trigger: 'change'}
                    ],
                    noticeType: [
                        {required: true, type: 'array', min: 1, message: '请选择报警方式', trigger: 'change'}
                    ],
                    monitorIndex: [
                        {required: true, message: '请选择监控指标', trigger: 'change', type: 'number'}
                    ],
                    cycle: [
                        {required: true, message: '请选择周期', trigger: 'change', type: 'number'}
                    ],
                    continousCycle: [
                        {required: true, message: '请选择连续周期', trigger: 'change', type: 'number'}
                    ],
                    statisticsValue: [
                        {required: true, message: '请选择统计数值', trigger: 'change', type: 'number'}
                    ],
                    relationshipSign: [
                        {required: true, message: '请选择关系符号', trigger: 'change', type: 'number'}
                    ],
                    thresholdValue: [
                        {required: true, message: '请输入阈值'}
                    ],
                    contactType: [
                        {required: true, message: '请选择联系方式', trigger: 'change', type: 'number'}
                    ],
                    contactGroupIds: [
                        {required: true, message: '请选择联系人组', trigger: 'change', type: 'array'}
                    ],
                    enterpriseWechatRobotIds: [
                      {required: true, type: 'array', message: '请选择企业微信机器人URL', trigger: 'change'}
                    ]
                },
                column: [
                    {
                        width: 60,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        type: 'selection'
                    },
                    {
                        field: 'storageGatewayName',
                        title: this.$t('alarms.storagegateway.storageGatewayName'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        field: 'region',
                        title: this.$t('alarms.common.region'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    }
                ],
                tableStorageGatewayDate: [],
                newTableStorageGatewayDateList: [],
                esList: [],
                compareStorageGatewayList:[]
            }
        },

        beforeCreate: function () {
            tableStorageGatewayWarningVue = this
        },
        methods: {
            //显示表格数据
            /****************************************************************/
            // 下一步
            nextPage: function () {
                this.isNext = true;
                this.isPrevious = false;
                // 查询监控指标
                tableStorageGatewayWarningVue.searchMonitorIndex();
                // 查询阈值
                tableStorageGatewayWarningVue.selectMonitorIndexDefault();
                // 查询联系人组
                tableStorageGatewayWarningVue.listContactGroups();
            },
            // 上一步
            previousPage: function () {
                this.isNext = false;
                this.isPrevious = true;
            },
            init: function (id) {
                this.storageGatewayWarningForm.id = id || 0;
                // 根据用户名查询Account列表
                tableStorageGatewayWarningVue.getAccount();
                this.$nextTick(() => {
                    // 重置表单
                    this.$refs['storageGatewayWarningForm'].resetFields();
                    // 编辑
                    if (this.storageGatewayWarningForm.id) {
                        // 编辑显示不能输入的规则名称
                        this.showRuleName = true;
                        this.isEdit = true;
                        this.isShowSearch = false;
                        this.$api.alertRule.selectAlertRule("id", this.storageGatewayWarningForm.id)
                            .then(res => {
                                //延时
                                this.storageGatewayWarningForm.alarmDelay = res.data.delay;
                              //监控时段
                              this.storageGatewayWarningForm.monitorPeriod = res.data.monitorPeriod;
                                // 账户
                                /******************************************************/
                                this.storageGatewayWarningForm.account = res.data.accountId;
                                tableStorageGatewayWarningVue.$api.account.queryAccountRegions("accountId", this.storageGatewayWarningForm.account)
                                .then(res => {
                                    this.backupRegionList = res.data;
                                });

                              // 查询通知对象
                              tableStorageGatewayWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                                "monitorModule":this.monitorModule,
                                "accountId":this.storageGatewayWarningForm.account
                              })
                                .then(res => {
                                  this.notificationObjectList = res.data.contactList;
                                });

                                this.modal_loadings = true;

                                setTimeout(() => {
                                    // 存储区域
                                    this.storageGatewayWarningForm.backupRegion = res.data.regions;

                                    // storageGateway列表
                                    /******************************************************/
                                    this.newTableStorageGatewayDateList = res.data.storageGatewayList;

                                    this.compareStorageGatewayList=res.data.storageGatewayList;
                                    // 根据AccountId查询存储网关列表
                                    tableStorageGatewayWarningVue.$api.storageGateway.queryStorageGateways({
                                        "regions": this.storageGatewayWarningForm.backupRegion,
                                        "accountId": this.storageGatewayWarningForm.account
                                    })
                                    .then(res => {
                                        this.tableStorageGatewayDate = res.data.records;
                                        this.modal_loadings = false;
                                        for (let i = 0; i < this.tableStorageGatewayDate.length; i++) {
                                            for (let j = 0; j < this.compareStorageGatewayList.length; j++) {
                                                if (this.tableStorageGatewayDate[i].storageGatewayName == this.compareStorageGatewayList[j].storageGatewayName) {
                                                    this.tableStorageGatewayDate[i]._checked = true;
                                                }
                                            }
                                        }
                                        // 选了数据 可以点击下一步
                                        if (this.tableStorageGatewayDate.length == 0 || this.compareStorageGatewayList.length == 0) {
                                            this.isNextClick = true;
                                        } else {
                                            this.isNextClick = false;
                                        }
                                    })
                                }, 1000)

                                // 规则名称
                                this.storageGatewayWarningForm.ruleName = res.data.alertRuleName;

                                // 监控指标
                                /******************************************************/
                                this.storageGatewayWarningForm.monitorIndex = res.data.monitorIndex;
                                // 如果监控指标为集群状态（黄色）、集群状态（红色）、主节点时 不显示符号、阈值和单位
                                if (this.storageGatewayWarningForm.monitorIndex == 48 || this.storageGatewayWarningForm.monitorIndex == 49 || this.storageGatewayWarningForm.monitorIndex == 50) {
                                    this.isShowField = 1;
                                } else {
                                    this.isShowField = 2;
                                }
                                // 周期
                                this.storageGatewayWarningForm.cycle = res.data.cycle;
                                // 连续周期
                                this.storageGatewayWarningForm.continousCycle = res.data.continousCycle;
                                // 统计数值
                                this.storageGatewayWarningForm.statisticsValue = res.data.statisticsValue;
                                // 符号
                                this.storageGatewayWarningForm.relationshipSign = res.data.relationshipSign;
                                // 阈值
                                this.storageGatewayWarningForm.thresholdValue = res.data.thresholdValue;
                                // 单位
                                this.storageGatewayWarningForm.unit = res.data.unit;
                                this.units = res.data.unitId;
                                // 企业微信机器人URL
                                this.storageGatewayWarningForm.enterpriseWechatRobotIds=res.data.enterpriseWechatRobotIds;

                                // 联系方式
                                this.storageGatewayWarningForm.contactType = res.data.contactType;
                                if(res.data.contactType==0){
                                    // 通知对象
                                    this.storageGatewayWarningForm.notificationObject = res.data.contactIDs;
                                    for(var i=0;i<this.storageGatewayWarningForm.notificationObject.length;i++){
                                      for(var j=0;j<this.notificationObjectList.length;j++){
                                        if(this.storageGatewayWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                                           this.storageGatewayWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                                        }
                                      }
                                    }
                                }else if(res.data.contactType==1){
                                    // 联系人组
                                    this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.storageGatewayWarningForm.account)
                                    .then(res => {
                                        this.contactGroupIdList = res.data;
                                    })
                                    setTimeout(() => {
                                        this.storageGatewayWarningForm.contactGroupIds = res.data.contactGroupIds;
                                    }, 1000)
                                }

                                // 报警方式
                                this.storageGatewayWarningForm.noticeType = res.data.noticeType;

                                for (var i = 0; i < this.storageGatewayWarningForm.noticeType.length; i++){

                                  if (this.storageGatewayWarningForm.noticeType[i] == '0') {
                                    this.isShowEmail = true;
                                    this.storageGatewayWarningForm.emailModal = res.data.briefReportBodyMail;
                                    this.noticeType = this.storageGatewayWarningForm.noticeType;
                                    tableStorageGatewayWarningVue.selectTemplate();
                                  }
                                  if (this.storageGatewayWarningForm.noticeType[i] == '1') {
                                    // this.isShowWeChat = true;
                                    this.storageGatewayWarningForm.wechatModal = res.data.briefReportBodyWechat;
                                    this.checkLeastOnePersonBoundWeChat();
                                    this.noticeType = this.storageGatewayWarningForm.noticeType;
                                    tableStorageGatewayWarningVue.selectTemplate();
                                  }else if(this.storageGatewayWarningForm.noticeType[i]!='1'){
                                      this.wechatWarningVisible=false;
                                      this.isAddOrEdit=false;
                                  }

                                }
                            })
                    } else {
                        this.tableStorageGatewayDate = [];
                        this.isEdit = false;
                        this.isShowSearch = true;
                        // 添加显示规则名称能输入
                        this.isEditRuleName = true;
                        this.showRuleName = false;
                    }
                })
                this.modal = true;
                this.isNext = false;
                this.isPrevious = true;
            },
            // 根据监控指标 显示不同单位
            /****************************************************************/
            // 清空周期、连续周期、统计数值、关系符号
            emptyDate: function () {
                this.storageGatewayWarningForm.cycle = '';
                this.storageGatewayWarningForm.continousCycle = '';
                this.storageGatewayWarningForm.statisticsValue = '';
                this.storageGatewayWarningForm.relationshipSign = '';
                this.storageGatewayWarningForm.thresholdValue = '';
            },
            isNotEmpty: function (obj) {
                if (typeof obj === "undefined" || obj === null || obj === "") {
                    return false;
                } else {
                    return true;
                }
            },
            // 根据监控指标 显示不同单位
            changeMonitorIndex: function () {
                // 如果监控指标为集群状态（黄色）、集群状态（红色）、主节点时 不显示符号、阈值和单位
                if (this.storageGatewayWarningForm.monitorIndex == 48 || this.storageGatewayWarningForm.monitorIndex == 49 || this.storageGatewayWarningForm.monitorIndex == 50) {
                    this.isShowField = 1;
                } else {
                    this.isShowField = 2;
                }
                tableStorageGatewayWarningVue.selectMonitorIndexDefault();
                this.unit = this.storageGatewayWarningForm.monitorIndex;
                for (var i = 0; i < this.monitorIndexList.length; i++) {
                    if (this.monitorIndexList[i].id == this.unit) {
                        this.storageGatewayWarningForm.unit = this.monitorIndexList[i].unit;
                        this.units = this.monitorIndexList[i].id;
                    }
                }
                tableStorageGatewayWarningVue.selectTemplate();
                tableStorageGatewayWarningVue.emptyDate();
            },
            // 查询阈值
            /****************************************************************/
            selectMonitorIndexDefault: function () {
                if (this.storageGatewayWarningForm.account == "" || this.storageGatewayWarningForm.account == null) {
                    return;
                }
                tableStorageGatewayWarningVue.$api.alertRule.selectMonitorIndexDefault({
                    "monitorIndex": this.storageGatewayWarningForm.monitorIndex,
                    "monitorModule": this.monitorModule,
                    "cycle": this.storageGatewayWarningForm.cycle,
                    "continousCycle": this.storageGatewayWarningForm.continousCycle,
                    "statisticsValue": this.storageGatewayWarningForm.statisticsValue,
                    "relationshipSign": this.storageGatewayWarningForm.relationshipSign,
                    "accountId": this.storageGatewayWarningForm.account
                })
                .then(res => {
                    // 周期
                    this.cycleList = res.data.cycleMap;
                    // 连续周期
                    this.continousCycleList = res.data.continousCycleMap;
                    // 统计数值
                    this.statisticsValueList = res.data.statisticsValueMap;
                    // 关系符号
                    this.relationshipSignList = res.data.relationshipSignMap;
                    // 阈值
                    if (res.data.companyMonitoritemVariablesList.length == 1 && tableStorageGatewayWarningVue.isNotEmpty(this.storageGatewayWarningForm.cycle) && tableStorageGatewayWarningVue.isNotEmpty(this.storageGatewayWarningForm.continousCycle) && tableStorageGatewayWarningVue.isNotEmpty(this.storageGatewayWarningForm.statisticsValue) && tableStorageGatewayWarningVue.isNotEmpty(this.storageGatewayWarningForm.relationshipSign) && this.storageGatewayWarningForm.id == 0) {
                        this.storageGatewayWarningForm.thresholdValue = res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
                    }

                })
            },
            // 查询邮件模板
            /****************************************************************/
            selectTemplate: function () {
                tableStorageGatewayWarningVue.$api.briefReport.selectTemplate({
                    "monitorIndex": this.storageGatewayWarningForm.monitorIndex,
                    "relationshipSign": this.storageGatewayWarningForm.relationshipSign,
                    "monitorModule": this.monitorModule,
                    "noticeType": this.storageGatewayWarningForm.noticeType
                })
                .then(res => {
                    this.storageGatewayWarningForm.wechatModal = res.data.briefReportBodyWechat;
                    this.storageGatewayWarningForm.emailModal = res.data.briefReportBodyMail;
                })
            },
            //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
            selectnoticeType: function () {
              this.isShowEmail = false;
              this.isShowWeChat = false;
              for(var i=0;i<this.storageGatewayWarningForm.noticeType.length;i++) {
                if (this.storageGatewayWarningForm.noticeType[i] == '0') {
                  this.isShowEmail = true;
                  this.noticeType = this.storageGatewayWarningForm.noticeType;
                  tableStorageGatewayWarningVue.selectTemplate();
                }
                if (this.storageGatewayWarningForm.noticeType[i] == '1') {
                  // this.isShowWeChat = true;
                  this.noticeType = this.storageGatewayWarningForm.noticeType;
                  this.checkLeastOnePersonBoundWeChat();
                  tableStorageGatewayWarningVue.selectTemplate();
                }else if(this.storageGatewayWarningForm.noticeType[i]!='1'){
                    this.wechatWarningVisible=false;
                    this.isAddOrEdit=false;
                }
              }
            },
            // 检查至少有一人绑定过微信
            checkLeastOnePersonBoundWeChat:function(){
              for(var i=0;i<this.storageGatewayWarningForm.noticeType.length;i++){
                  if(this.storageGatewayWarningForm.noticeType[i]==1){
                      var weChatDate={
                          "contactType":this.storageGatewayWarningForm.contactType
                      };
                      // 联系方式为 -联系人-
                      if(this.storageGatewayWarningForm.contactType==0){
                          weChatDate.userIds=this.storageGatewayWarningForm.userIdList;
                      }
                      // 联系方式为 -联系人组-
                      else if(this.storageGatewayWarningForm.contactType==1){
                          weChatDate.contactGroupIds = this.storageGatewayWarningForm.contactGroupIds;
                      }
                      this.$api.userWeChat.checkLeastOnePersonBoundWeChat(weChatDate)
                      .then(res => {
                          if(res.data){
                            // 可以添加告警
                            this.wechatWarningVisible=false;
                            this.isAddOrEdit=false;
                          }else{
                            // 不可以添加微信告警
                            this.wechatWarningVisible=true;
                            this.isAddOrEdit=true;
                          }
                      })
                  }else if(this.storageGatewayWarningForm.noticeType[i]!=1){
                      this.wechatWarningVisible=false;
                      this.isAddOrEdit=false;
                  }
              }
            },
            // 联系人组
            listContactGroups:function(){
                this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.storageGatewayWarningForm.account)
                .then(res => {
                    this.contactGroupIdList = res.data;
                })
            },
            // 切换联系人组
            changeContactGroupId:function(){
               this.checkLeastOnePersonBoundWeChat();
            },
            // 切换通知对象
            changeNotificationObject:function(val){
              this.storageGatewayWarningForm.userIdList=[];
              this.storageGatewayWarningForm.notificationObject=val;
              for(var i=0;i<this.storageGatewayWarningForm.notificationObject.length;i++){
                for(var j=0;j<this.notificationObjectList.length;j++){
                  if(this.storageGatewayWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                     this.storageGatewayWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                  }
                }
              }
              this.checkLeastOnePersonBoundWeChat();
            },
            // 切换联系方式
            changeContactType:function(){
              this.checkLeastOnePersonBoundWeChat();
            },
            //点击查询 加载全部数据
            /***********************************************************************************/
            searchStorageGatewayDate: function () {
                if (this.storageGatewayWarningForm.account == "" || this.storageGatewayWarningForm.account == null || this.storageGatewayWarningForm.backupRegion == "" || this.storageGatewayWarningForm.backupRegion == null) {
                    return;
                }
                this.modal_loadings = true;
                // 根据AccountId查询存储网关列表
                tableStorageGatewayWarningVue.$api.storageGateway.queryStorageGateways({
                    "regions": this.storageGatewayWarningForm.backupRegion,
                    "accountId": this.storageGatewayWarningForm.account
                })
                .then(res => {
                    this.tableStorageGatewayDate = res.data.records;
                    this.modal_loadings = false;
                })
            },

            /**************************************  查询  **************************************/
            // 查询监控指标
            searchMonitorIndex: function () {
                tableStorageGatewayWarningVue.$api.alertRule.searchMonitorIndex({
                  "monitorModule":this.monitorModule,
                  "accountId":this.storageGatewayWarningForm.account
                })
                .then(res => {
                    this.monitorIndexList = res.data;
                })
            },
            // 查询通知对象
            queryContacts: function () {
                tableStorageGatewayWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                  "monitorModule":this.monitorModule,
                  "accountId":this.storageGatewayWarningForm.account
                })
                .then(res => {
                    this.notificationObjectList = res.data.contactList;
                    this.storageGatewayWarningForm.notificationObject = res.data.defaultContactIds;
                })
            },
            // 查询报警方式
            alarmWay: function () {
                tableStorageGatewayWarningVue.$api.alertRule.alarmWay("userName",getCookie(global.cookieName))
                .then(res => {
                  this.alarmWayList = res.data;
              })
            },
             // 查询报警延迟
            getAlarmDelay: function () {
                tableStorageGatewayWarningVue.$api.alertRule.alarmDelay("userName",getCookie(global.cookieName))
                .then(res => {
                  this.alarmDelayList = res.data;
              })
            },
          // 查询监控时间段
          searchMonitorPeriod: function(){
            this.$api.alertRule.monitorPeriod("userName",getCookie(global.cookieName))
              .then(res => {
                this.monitorPeriodList = res.data;
              })
          },
            // 周期
            changeCycle: function () {
                // 查询阈值
                tableStorageGatewayWarningVue.selectMonitorIndexDefault();
            },
            // 连续周期
            changeContinousCycle: function () {
                // 查询阈值
                tableStorageGatewayWarningVue.selectMonitorIndexDefault();
            },
            // 统计数值
            changeStatisticsValue: function () {
                // 查询阈值
                tableStorageGatewayWarningVue.selectMonitorIndexDefault();
            },
            // 关系符号
            changeRelationshipSign: function () {
                // 查询阈值
                tableStorageGatewayWarningVue.selectMonitorIndexDefault();
                // 邮件模板
                tableStorageGatewayWarningVue.selectTemplate();
            },
            // 根据用户名查询Account列表
            getAccount: function () {
                // 清空表格
                this.tableStorageGatewayDate = [];
                tableStorageGatewayWarningVue.$api.account.queryAccounts("userName", getCookie(global.cookieName))
                .then(res => {
                    this.accountList = res.data;
                    for (var i = 0; i < this.accountList.length; i++) {
                        this.accountList[i].name = this.accountList[i].name + '(' + this.accountList[i].accountTypeName + ')';
                    }
                })
                // 查询方式
                tableStorageGatewayWarningVue.alarmWay();
                 // 查询报警延时
                tableStorageGatewayWarningVue.getAlarmDelay();
                //监控时段
                tableStorageGatewayWarningVue.searchMonitorPeriod();
                // 监控模块查询关联的机器人列表
                tableStorageGatewayWarningVue.listEnterpriseWechatRobotsByMonitorModule();
            },
            // 监控模块查询关联的机器人列表
            listEnterpriseWechatRobotsByMonitorModule:function(){
                tableStorageGatewayWarningVue.$api.enterpriseWechatRobot.listEnterpriseWechatRobotsByMonitorModule({
                  "monitorModule":this.monitorModule
                })
                .then(res => {
                  this.enterpriseWechatRobotIdsList = res.data;
                })
            },
            // 选择账户
            changeAccount: function () {
                if (this.storageGatewayWarningForm.account == "" || this.storageGatewayWarningForm.account == null) {
                    return;
                }
                this.storageGatewayWarningForm.backupRegion = '';
                // 清空表格
                this.tableStorageGatewayDate = [];
                this.esList = [];
                this.isShowSearch = true;
                this.isNextClick = true;
                tableStorageGatewayWarningVue.$api.account.queryAccountRegions("accountId", this.storageGatewayWarningForm.account)
                .then(res => {
                    this.backupRegionList = res.data;
                });
                // 查询通知对象
                tableStorageGatewayWarningVue.queryContacts();
                // 查询联系人组
                tableStorageGatewayWarningVue.listContactGroups();
            },
            /***********存储区域**************************/
            selectBackupRegionAll(){
                this.storageGatewayWarningForm.backupRegion = []
                if (this.singleBackupRegion) {
                    this.backupRegionList.map((item) => {
                        this.storageGatewayWarningForm.backupRegion.push(item.name)
                    })
                } else {
                    this.storageGatewayWarningForm.backupRegion = []
                }
            },
            // 切换存储区域
            changebackupRegion: function (val) {
                if (val.length === this.backupRegionList.length&&val.length!=0) {
                    this.singleBackupRegion = true
                } else {
                    this.singleBackupRegion = false
                }
                // 表格数据为空、显示查询按钮、存储区域为空
                this.tableStorageGatewayDate = [];
                this.esList = [];
                this.isShowSearch = true;
                this.isNextClick = true;
            },
            // 全选 单选
            /***********************************************************************************/
            // 单选
            selectChange(selection) {
                // 所有数据
                this.selection = selection;
                // 清空数组
                this.newTableStorageGatewayDateList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    var TableStorageGatewayCopy = new Object();
                    TableStorageGatewayCopy.storageGatewayName = this.selection[i].storageGatewayName;
                    TableStorageGatewayCopy.storageGatewayId = this.selection[i].storageGatewayId;
                    TableStorageGatewayCopy.accountId = this.selection[i].accountId;
                    TableStorageGatewayCopy.region = this.selection[i].region;
                    this.newTableStorageGatewayDateList.push(TableStorageGatewayCopy);
                }
                // 选了数据 可以点击下一步
                if (this.newTableStorageGatewayDateList.length == 0) {
                    this.isNextClick = true;
                } else {
                    this.isNextClick = false;
                }
            },
            // 全选
            selectAll: function (selection) {
                // 所有数据
                this.selection = selection;
                // 清空数组
                this.newTableStorageGatewayDateList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    // 状态
                    var TableStorageGatewayCopy = new Object();
                    TableStorageGatewayCopy.storageGatewayName = this.selection[i].storageGatewayName;
                    TableStorageGatewayCopy.storageGatewayId = this.selection[i].storageGatewayId;
                    TableStorageGatewayCopy.accountId = this.selection[i].accountId;
                    TableStorageGatewayCopy.region = this.selection[i].region;
                    this.newTableStorageGatewayDateList.push(TableStorageGatewayCopy);
                }
                if (this.selection.length == 0) {
                    this.isNextClick = true;
                } else {
                    this.isNextClick = false;
                }
            },
            // 创建添加或编辑报警
            /**********************************************************************************/
            ok: function (name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        var alertList = {
                            "alertRuleName": this.storageGatewayWarningForm.ruleName,
                            "monitorIndex": this.storageGatewayWarningForm.monitorIndex,
                            "cycle": this.storageGatewayWarningForm.cycle,
                            "continousCycle": this.storageGatewayWarningForm.continousCycle,
                            "statisticsValue": this.storageGatewayWarningForm.statisticsValue,
                            "relationshipSign": this.storageGatewayWarningForm.relationshipSign,
                            "accountId": this.storageGatewayWarningForm.account,
                            "monitorModule": this.monitorModule,
                            "noticeType": this.storageGatewayWarningForm.noticeType,
                            "unit": this.units,
                            "delay":this.storageGatewayWarningForm.alarmDelay,
                            "monitorPeriod":this.storageGatewayWarningForm.monitorPeriod,
                            "thresholdValue":this.storageGatewayWarningForm.thresholdValue,
                            "contactType":this.storageGatewayWarningForm.contactType,
                            "enterpriseWechatRobotIds":this.storageGatewayWarningForm.enterpriseWechatRobotIds
                        };

                         // 如果联系方式是联系人 传通知对象
                        if(this.storageGatewayWarningForm.contactType == 0){
                            alertList.contactIDs = this.storageGatewayWarningForm.notificationObject;
                        }
                        // 如果联系方式是联系人组 传联系人组
                        else if(this.storageGatewayWarningForm.contactType == 1){
                          alertList.contactGroupIds = this.storageGatewayWarningForm.contactGroupIds;
                        }

                        if (this.storageGatewayWarningForm.id > 0) {
                            alertList.id = this.storageGatewayWarningForm.id;
                            alertList.resourceStoragegatewayDTOList = this.newTableStorageGatewayDateList;
                            // 编辑告警
                            this.addloading=true;
                            tableStorageGatewayWarningVue.$api.alertRule.updateAlertRule(alertList)
                                .then(res => {
                                    this.data = res.data;
                                    setTimeout(() => {
                                        this.reload();
                                        this.storageGatewayWarningForm.notificationObject = [];
                                        this.$refs[name].resetFields();
                                        this.loading = false;
                                        this.$emit('on-ok', this.form);
                                        this.$nextTick(() => {
                                            this.loading = true;
                                        });
                                        this.$Message.success('编辑成功');
                                        // 禁止点击下一步
                                        this.isNextClick = true;
                                        this.isShowSearch = false;
                                        this.isShowEmail = false;
                                        this.isShowWeChat = false;
                                        this.addloading=false;
                                        this.modal = false;
                                        this.wechatWarningVisible=false;
                                        this.isAddOrEdit=true;
                                    }, 1000);
                                })
                        } else {
                            // 添加告警
                            this.addloading=true;
                            alertList.resourceStoragegatewayDTOList = this.newTableStorageGatewayDateList;
                            tableStorageGatewayWarningVue.$api.alertRule.createAlertRule(alertList)
                                .then(res => {
                                    this.data = res.data;
                                    setTimeout(() => {
                                        this.reload();
                                        tableStorageGateway.methods.showAll();
                                        this.storageGatewayWarningForm.notificationObject = [];
                                        this.$refs[name].resetFields();
                                        this.loading = false;
                                        this.$emit('on-ok', this.form);
                                        this.$nextTick(() => {
                                            this.loading = true;
                                        });
                                        this.$Message.success('添加成功');
                                        // 禁止点击下一步
                                        this.isNextClick = true;
                                        this.isShowEmail = false;
                                        this.isShowWeChat = false;
                                        this.addloading=false;
                                        this.modal = false;
                                        this.wechatWarningVisible=false;
                                        this.isAddOrEdit=true;
                                    }, 1000);
                                })
                        }
                    } else {
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        if (this.storageGatewayWarningForm.id > 0) {
                            this.$Message.error('编辑失败');
                        } else {
                            this.$Message.error('添加失败');
                        }
                    }
                });
            },
            // 取消
            cancel: function (name) {
                this.wechatWarningVisible=false;
                this.isAddOrEdit=true;
                this.isShowSearch = false;
                this.isShowEmail = false;
                this.isShowWeChat = false;
                this.isNextClick = true;
                this.modal = false;
                this.$emit('on-cancel');
                this.storageGatewayWarningForm.notificationObject = [];
                this.$nextTick(() => {
                    this.$refs[name].resetFields();
                });
                // 清空表格
                this.tableStorageGatewayDate = [];
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/storage_gateway/AddOrUpdateStorageGatewayWarning.vue